export enum Playback {
    MULTI_CDN = 'x-cdn',
    VIDEO = 'video',
    AUDIO = 'audio',
    TEXT = 'text',
}
